"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _ = require("../");

var _excluded = ["defaultValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MaskedInput = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_reactTextMask["default"], (0, _extends2["default"])({}, props, {
    ref: ref,
    render: function render(ref, _ref) {
      var defaultValue = _ref.defaultValue,
          props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_.Input, (0, _extends2["default"])({
        ref: ref,
        value: defaultValue
      }, props));
    }
  }));
});

MaskedInput.displayName = 'MaskedInput';
MaskedInput.defaultProps = _.Input.defaultProps;
MaskedInput.time = ( /*#__PURE__*/0, _styledBase["default"])(MaskedInput, {
  target: "e41ycu60"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01hc2tlZElucHV0L01hc2tlZElucHV0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9Cc0MiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvTWFza2VkSW5wdXQvTWFza2VkSW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IFRleHRNYXNrIGZyb20gJ3JlYWN0LXRleHQtbWFzayc7XG5cbmltcG9ydCB7IElucHV0IH0gZnJvbSAnLi4vJztcblxuY29uc3QgTWFza2VkSW5wdXQgPSBSZWFjdC5mb3J3YXJkUmVmKChwcm9wcywgcmVmKSA9PiAoXG4gIDxUZXh0TWFza1xuICAgIHsuLi5wcm9wc31cbiAgICByZWY9e3JlZn1cbiAgICByZW5kZXI9eyhyZWYsIHsgZGVmYXVsdFZhbHVlLCAuLi5wcm9wcyB9KSA9PiAoXG4gICAgICA8SW5wdXQgcmVmPXtyZWZ9IHZhbHVlPXtkZWZhdWx0VmFsdWV9IHsuLi5wcm9wc30gLz5cbiAgICApfVxuICAvPlxuKSk7XG5cbk1hc2tlZElucHV0LmRpc3BsYXlOYW1lID0gJ01hc2tlZElucHV0JztcblxuTWFza2VkSW5wdXQuZGVmYXVsdFByb3BzID0gSW5wdXQuZGVmYXVsdFByb3BzO1xuXG5NYXNrZWRJbnB1dC50aW1lID0gc3R5bGVkKE1hc2tlZElucHV0KWBgO1xuTWFza2VkSW5wdXQudGltZS5kaXNwbGF5TmFtZSA9ICdNYXNrZWRJbnB1dC50aW1lJztcbk1hc2tlZElucHV0LnRpbWUuZGVmYXVsdFByb3BzID0ge1xuICAuLi5NYXNrZWRJbnB1dC5kZWZhdWx0UHJvcHMsXG4gIGtlZXBDaGFyUG9zaXRpb25zOiB0cnVlLFxuICBwbGFjZWhvbGRlckNoYXI6ICdcXHUyMDAwJyxcbiAgbWFzazogWy9bMC0yXS8sIC9bMC05XS8sICc6JywgL1swLTZdLywgL1swLTldLywgJyBBRVNUJ10sXG4gIHBsYWNlaG9sZGVyOiAnMDA6MDAgQUVTVCcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBNYXNrZWRJbnB1dDtcbiJdfQ== */");
MaskedInput.time.displayName = 'MaskedInput.time';
MaskedInput.time.defaultProps = _objectSpread(_objectSpread({}, MaskedInput.defaultProps), {}, {
  keepCharPositions: true,
  placeholderChar: "\u2000",
  mask: [/[0-2]/, /[0-9]/, ':', /[0-6]/, /[0-9]/, ' AEST'],
  placeholder: '00:00 AEST'
});
var _default = MaskedInput;
exports["default"] = _default;